:host {
  display: block;
  position: relative;
  min-height: 100vh;
}

.app-container {
  min-height: 100vh;
}

/* 
.search-bar-container {
  position: relative;
  z-index: 10;
} */
